import { css } from '@/styled-system/css';

export const styledContainerStyles = css({
  maxHeight: '500px',
  overflowY: 'scroll',
});

export const getStyledTextStyles = (odd: boolean) =>
  css({
    ...(odd && { background: 'bg.neutral.secondary' }),
  });
